export const INDEFINITE_END_DATE = '2999-12-31T23:59:59Z';
